import React from 'react';
import { useTranslation } from 'react-i18next';
import WorkbenchHeaderBar from './WorkbenchHeaderBar';
import '@/styles/ipe/workbench/GoodsDetailPage.css';
import '@/styles/ipe/workbench/Img2ImgDetailPage.css';
import '@/styles/ipe/workbench/ipe-workbench.css';

export default function WorkbenchDetailPageShell({
  children,
  onOpenAccountCenter,
  pageClassName = '',
  shellClassName = '',
}) {
  const { t } = useTranslation('workbench');
  const pageClasses = ['img2img-detail-page', pageClassName].filter(Boolean).join(' ');
  const shellClasses = ['img2img-detail-shell', 'fullscreen-page', shellClassName].filter(Boolean).join(' ');

  return (
    <div className={shellClasses}>
      <header className="img2img-detail__top-rail" aria-label={t('ipeWorkbench.topBarAria')}>
        <WorkbenchHeaderBar onOpenAccountCenter={onOpenAccountCenter} />
      </header>
      <div className={pageClasses}>{children}</div>
    </div>
  );
}
